import type {Action} from 'platform/components';
import {match} from 'ts-pattern';

import i18n from '@dms/i18n';

import type {ChartLayoutState} from '../hooks/useChartLayout';

/**
 * Page header actions of the chart layout, as on the DMS home page: "Customise dashboard", or
 * "Reset layout", "Cancel" and "Save" while the layout is edited. There are none while the
 * layout is not available, see `ChartLayoutState.isAvailable`.
 */
export function getChartLayoutActions(layout: ChartLayoutState) {
  return match({isAvailable: layout.isAvailable, isEditing: layout.isEditing})
    .returnType<Action[]>()
    .with({isEditing: true}, () => [
      {
        type: 'button',
        variant: 'ghost',
        title: i18n.t('page.homepage.dashboardLayout.resetLayout'),
        onClick: layout.resetLayout,
        'data-testid': 'chart-layout-reset',
      },
      {
        type: 'button',
        variant: 'ghost',
        title: i18n.t('general.actions.cancel'),
        onClick: layout.cancelEditing,
        'data-testid': 'chart-layout-cancel',
      },
      {
        type: 'button',
        variant: 'primary',
        title: i18n.t('general.actions.save'),
        onClick: layout.saveLayout,
        'data-testid': 'chart-layout-save',
      },
    ])
    .with({isAvailable: true}, () => [
      {
        type: 'button',
        variant: 'secondary',
        leftIcon: 'action/dashboard',
        title: i18n.t('page.homepage.dashboardLayout.customise'),
        onClick: layout.startEditing,
        'data-testid': 'chart-layout-customise',
      },
    ])
    .otherwise(() => []);
}
